import { selectCurrency } from '@/redux/config/configSlice';
import { TicketDiscountType } from '@/redux/data/dataTypes';
import { useAppSelector } from '@/redux/hooks';
import { DeleteOutlined } from '@ant-design/icons';
import { Button, List, Typography } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface DiscountsSlideUpProps {
  discounts?: TicketDiscountType[];
  editable?: boolean;
  onRemoveDiscount?: (discount: TicketDiscountType) => void;
}

const DiscountsSlideUp: FC<DiscountsSlideUpProps> = ({
  discounts = [],
  editable = false,
  onRemoveDiscount,
}) => {
  const { t } = useTranslation();
  const currency = useAppSelector(selectCurrency);

  const handleRemoveDiscount = (discount: TicketDiscountType) => {
    if (onRemoveDiscount) {
      onRemoveDiscount(discount);
    }
  };

  return (
    <div className="p-4">
      <Typography.Title level={4} className="mb-4">
        {t('common:discounts')}
      </Typography.Title>
      {discounts.length === 0 ? (
        <Typography.Text className="text-gray-500">{t('common:no_discounts')}</Typography.Text>
      ) : (
        <List
          dataSource={discounts}
          renderItem={(discount) => (
            <List.Item
              actions={
                editable
                  ? [
                      <Button
                        key="delete"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => handleRemoveDiscount(discount)}
                      />,
                    ]
                  : []
              }
            >
              <List.Item.Meta
                title={discount.name}
                description={
                  discount.type === 'PERCENT'
                    ? `${discount.value}%`
                    : `${discount.value} ${currency}`
                }
              />
            </List.Item>
          )}
        />
      )}
    </div>
  );
};

export default DiscountsSlideUp;
